/**@preserve
 * Login code
 * Authors: Adam A. Koch, Matt Kasselman, Zach Leatherman and probably others
 * Copyright (c) 2008-2010 Union Pacific - All rights reserved
 * http://www.up.com
 */
import parseUri from './parseuri';
import $ from 'jquery';
import Cookies from 'js-cookie';

import errorAlert from '../common/error-alert.service';

// FIXME This is straight ported from previous login code. It can/should be refactored
$(function() {
  var /**
     * @const
     */
    SENT_TO_401_COOKIE_NAME = 'UITSENTTO401',
    /**
     * @const
     */
    LAST_LOGIN_ATTEMPT_COOKIE_NAME = 'UITLASTLOGINATTEMPT',
    /**
     * @const
     */
    FOUR_O_ONE_PAGE_PATH = '/admin/error/401.shtml',
    /**
     * @const
     */
    SUSPENDED_ACCOUNT_PAGE_PATH = '/admin/error/401-suspended.shtml',
    /**
     * @const
     */
    // Is 30 the number of minutes a Siteminder cookie is valid?
    SITEMINDER_SESSION_TIMEOUT_MINUTES = 30,
    /**
     * @const
     */
    SITEMINDER_TRY_NUMBER_COOKIE_NAME = 'SMTRYNO',
    //SiteMinder variables
    uri = parseUri(document.location),
    SM_authReason = uri.queryKey.SMAUTHREASON,
    SM_target = uri.queryKey.TARGET;

  // Sends user to the expired password page
  function sendToExpired() {
    window.location.href = '/admin/error/ssl/expired.shtml?target=' + SM_target;
  }

  function getMinutesDifference(after, before) {
    return (after - before) / (1000 * 60);
  }

  function sessionProbablyExpired() {
    var now = +new Date(),
      then = Cookies.get(LAST_LOGIN_ATTEMPT_COOKIE_NAME) || +new Date(),
      minutesSinceLastLoginAttempt = getMinutesDifference(now, then);

    return minutesSinceLastLoginAttempt > SITEMINDER_SESSION_TIMEOUT_MINUTES;
  }

  function displayLoginFailedMessage() {
    var count,
      countCookie = Cookies.get(SITEMINDER_TRY_NUMBER_COOKIE_NAME);

    if (countCookie) {
      count = parseInt(countCookie, 10);

      // This will redirect to the 401 if multiple of 3 login page views
      // have occurred
      if (count % 3 === 0 && !Cookies.get(SENT_TO_401_COOKIE_NAME)) {
        Cookies.set(SENT_TO_401_COOKIE_NAME, true);
        window.location.pathname = FOUR_O_ONE_PAGE_PATH;
      } else {
        Cookies.set(SENT_TO_401_COOKIE_NAME, null);

        if (count > 0) {
          if (sessionProbablyExpired()) {
            errorAlert.show('unknown');
          } else {
            Cookies.set(LAST_LOGIN_ATTEMPT_COOKIE_NAME, +new Date());
            errorAlert.show('failure');
          }
        }
      }
    }
  }

  if (SM_authReason) {
    // SM_authReason is set on login.fcc in a script tag by Siteminder
    switch (parseInt(SM_authReason, 10)) {
      case 6:
      case 7:
      case 2001:
        sendToExpired();
        return;
      case 1001:
        window.location.href = SUSPENDED_ACCOUNT_PAGE_PATH;
        return;
      default:
        //Includes case 32002
        displayLoginFailedMessage();
    }
  }

  // Supposedly the statistics software can't do case insensitive search.
  // Haven't confirmed this directly with the WebTrends folks.
  $('#USER').bind('blur', function() {
    var $t = $(this);
    $t.val($t.val().toLowerCase());
  });
});
